import React from 'react';
import { arrayOf, string } from 'prop-types';
import SectionHead from './SectionHead';

/** "Was gehört zu ...?" — an intro plus a checklist of considerations. */
const Explainer = props => {
  const { heading, text, items } = props;
  if (!heading) {
    return null;
  }
  return (
    <section aria-labelledby="what-title">
      <div className="container">
        <SectionHead id="what-title" heading={heading} text={text} />
        <ul className="checklist">
          {items.map(item => (
            <li key={item}>
              <h3>{item}</h3>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

Explainer.propTypes = { heading: string, text: string, items: arrayOf(string) };
Explainer.defaultProps = { items: [] };

export default Explainer;
